import { WebStorageStateStore, InMemoryWebStorage } from 'oidc-client-ts';

// Values come from production-tools/infra/shared/cognito.tf (Session 1).
const userPoolId = process.env.REACT_APP_COGNITO_USER_POOL_ID;
const region = userPoolId ? userPoolId.split('_')[0] : 'eu-central-1';

export const oidcConfig = {
  authority: `https://cognito-idp.${region}.amazonaws.com/${userPoolId}`,
  client_id: process.env.REACT_APP_COGNITO_CLIENT_ID,
  redirect_uri: process.env.REACT_APP_COGNITO_REDIRECT_URI || `${window.location.origin}/callback`,
  post_logout_redirect_uri: window.location.origin + '/',
  response_type: 'code',
  scope: 'openid email profile',
  // Proactively renews the access token before its 1-hour expiry while a
  // user is logged in. This does NOT use the iframe/third-party-cookie
  // mechanism that caused the slow page-load issue: oidc-client-ts prefers
  // the refresh_token grant (a plain POST to Cognito's token endpoint)
  // whenever the current user has a refresh token, which Cognito issues
  // at login — so this only falls back to the iframe path (which would
  // need silent_redirect_uri, deliberately left unset) if that's ever
  // missing, in which case it just fails harmlessly (see AuthProvider.js's
  // softened onSilentRenewError handling).
  automaticSilentRenew: true,
  // Tokens live only in memory, never on disk — reduces the window an XSS
  // payload could exfiltrate a token to "while this page is open" rather
  // than indefinitely. A full page reload always requires a fresh
  // top-level redirect to Cognito (see AuthProvider.js) since nothing
  // persists across reloads.
  userStore: new WebStorageStateStore({ store: new InMemoryWebStorage() }),
};

export const cognitoLogoutUrl = () => {
  const domain = process.env.REACT_APP_COGNITO_DOMAIN;
  const clientId = process.env.REACT_APP_COGNITO_CLIENT_ID;
  const logoutUri = window.location.origin + '/';
  return `${domain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
};
